import { render, staticRenderFns } from "./FeedTags_Icon_Search.vue?vue&type=template&id=129bfd00&scoped=true&"
import script from "./FeedTags_Icon_Search.vue?vue&type=script&lang=js&"
export * from "./FeedTags_Icon_Search.vue?vue&type=script&lang=js&"
import style0 from "./FeedTags_Icon_Search.vue?vue&type=style&index=0&id=129bfd00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129bfd00",
  null
  
)

export default component.exports